import React from "react";

import MaterialTable from 'material-table';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";

import axios from 'axios';
import { API_ROOT } from 'api-config';
import { getApiHeaders } from '../../assets/helpers/apiHelper.jsx';
import { convertToDisplayDate } from '../../assets/helpers/dataHelper.jsx';

class PmsSearch extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    const providerId = props.providerId
    this.searchPatients = this.searchPatients.bind(this);
    this.state = {
      userId: sessionStorage.getItem('userId'),
      searchButtonText: 'search',
      searchStatusIndicator: '',
      firstName: '',
      lastName: '',
      inputDisabled: false,
      searchResults: '',
      providerId: providerId,
      searchResultsTableData: [{ firstName: '', lastName: '', dob: '' }],
    };
  }

  componentDidMount(){
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  searchPatients = (e) => {
    e.preventDefault();
    //validate fields
    if (this.state.firstName === '' && this.state.lastName === '') {
      this.setState({
        searchResults: 'Please enter either a first or last name, or both.'
      });
    } else {
      const searchStatusIndicator = <CircularProgress size={20}/>
      this.setState({
        inputDisabled: true,
        searchButtonText: 'searching',
        searchStatusIndicator: searchStatusIndicator,
        searchResults: '',
        searchResultsTableData: [{ firstName: 'loading...', lastName: 'loading...', dob: 'loading...' }]
      })
      axios.get(`${API_ROOT}/gateway/patients/?userId=` + this.state.providerId + `&firstName=` + this.state.firstName + `&lastName=` + this.state.lastName, { headers: getApiHeaders() })
        .then(res => this.handleSearchResponse(res.data));
    }
  }

  handleSearchResponse(res) {
    if (this._isMounted) {
      if (res === 'error') {
        this.setState({
          searchButtonText: 'search',
          searchStatusIndicator: '',
          inputDisabled: false,
          searchResults: 'We were not able to search you PMS. Please verify that the PMS server is available and connected to the internet.',
          searchResultsTableData: [{ firstName: '', lastName: '', dob: '' }]
        });
      } else {
        const searchResults = res
        let row;
        let buttonAction;
        for (row in searchResults) {
          searchResults[row]['dob'] = convertToDisplayDate(searchResults[row]['dob'])
          buttonAction = (
            <div>
              {/* use this button to add a edit kind of action */}
              <Button
                simple
                onClick={this.selectPmsPatient.bind(this, searchResults[row]['personId'])}
                className="edit"
                color="cirrusBlue"
                id={"selectPmsPatientButton_" + searchResults[row]['personId']}
                name={"selectPmsPatientButton_" + searchResults[row]['personId']}
              >
                use patient
              </Button>{" "}
            </div>
          )
          searchResults[row]['action'] = buttonAction;
        }
        this.setState({
          searchButtonText: 'search',
          searchStatusIndicator: '',
          inputDisabled: false,
          searchResultsTableData: searchResults,
          searchResults: ''
        });
      }

    }
  }

  selectPmsPatient(patientId) {
    const selectedPmsPatient = this.state.searchResultsTableData.find(o => o.personId === patientId);
    if (this.props.populatePatientData) {
      this.props.populatePatientData(selectedPmsPatient)
    }
  }
  render() {
    return (
        <Card>
          <CardBody>

            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  labelText="first name"
                  type="text"
                  id="firstName"
                  formControlProps={{
                    fullWidth: true,
                    margin: this.state.formControlMargin
                  }}
                  inputProps={{
                    onChange: this.handleChange,
                    value: this.state.firstName,
                    disabled: this.state.inputDisabled
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  labelText="last name"
                  type="text"
                  id="lastName"
                  formControlProps={{
                    fullWidth: true,
                    margin: this.state.formControlMargin
                  }}
                  inputProps={{
                    onChange: this.handleChange,
                    value: this.state.lastName,
                    disabled: this.state.inputDisabled
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <Button
                  round
                  onClick={this.searchPatients}
                  color="cirrusBlue"
                  disabled={this.state.inputDisabled}
                  id="searchPmsButton"
                >
                  {this.state.searchButtonText}
                </Button>
                {this.state.searchStatusIndicator}
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                {this.state.searchResults}
                <MaterialTable
                  title=''
                  columns={[
                    { title: 'first name', field: 'firstName'},
                    { title: 'last name', field: 'lastName' },
                    { title: 'DOB', field: 'dob' },
                    { title: '', field: 'action' },
                  ]}
                  data={this.state.searchResultsTableData}
                  options={{
                    search: false
                  }}
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
    )

  }


}

export default withStyles(userProfileStyles)(PmsSearch);